import React, { useState, useEffect } from 'react'
import styled, { withTheme } from 'styled-components'
import cn from 'classnames'
import { get } from 'lodash'

const Navs = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  text-align: right;
`
const NavItem = styled.li`
  position: relative;
  margin: 0;
  padding: 0 20px;
  cursor: pointer;
  display: inline-block;
  line-height: ${(props) => (props.theme.size === 'large' ? '60px' : '50px')};
  transition: background-color 0.5;

  a {
    font-size: 14px;
    color: ${(props) => props.theme.secondaryTextColor};
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    .tnt-themeS1 & {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  &:hover,
  &.active {
    a {
      color: ${(props) => props.theme.primaryColor};
      .tnt-themeS1 & {
        color: #418aff;
      }
    }
  }
  &.active {
    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 3px;
      background: ${(props) => props.theme.primaryColor};
      display: inline-block;
      content: '';
      .tnt-themeS1 & {
        background: #418aff;
      }
    }
  }
`

export const HeaderNavs = withTheme(({ theme, navs = [], onChange, onSelect, ...props }) => {
  const [selectedKey, setSelectedKey] = useState(props.selectedKey || get(navs, '0.key'))
  const onClickNav = (nav) => {
    setSelectedKey(nav.key)
    onSelect && onSelect(nav)

    if (selectedKey !== nav.key) {
      onChange && onChange(nav)
      setSelectedKey(nav.key)
    }
  }

  useEffect(() => {
    setSelectedKey(props.selectedKey || get(navs, '0.key'))
  }, [navs, props.selectedKey])

  return (
    <Navs {...props}>
      {navs.map((nav) => (
        <NavItem
          key={nav.key}
          theme={theme}
          className={cn({ active: selectedKey === nav.key })}
          onClick={() => onClickNav(nav)}
        >
          <a href={nav.key} onClick={(evt) => evt.preventDefault()}>
            {nav.name}
          </a>
        </NavItem>
      ))}
    </Navs>
  )
})

export default HeaderNavs
